import { Dialog } from "primereact/dialog"

import { Button, TextAreaField } from "../../../../helpers"


const PaymentTermsApprovalRemarks = (props) => {

    const { paymentTermsRemarks, isApprovalReq, buyerPoCreatedAtDate, setPaymentTermsRemarks, setVisiblePaymentTermsRemarks, handlePaymentTermsRemarksSubmitClick, visiblePaymentTermRemarks } = props

    const noOfDaysTakenToCreateSellerPO = Math.floor((new Date().setHours(0, 0, 0, 0) - new Date(buyerPoCreatedAtDate).setHours(0, 0, 0, 0)) / (1000 * 60 * 60 * 24))
    const handlePaymentTermsOnChange = (e) => {
        setPaymentTermsRemarks(e.target.value)
    }

    const paymentTermsRemarksFooter = () => {
        return (
            <div className="mt-2">
                <Button label="Cancel" severity="danger" outlined onClick={() => { setVisiblePaymentTermsRemarks(false); setPaymentTermsRemarks(''); }} />
                <Button label="Continue" outlined onClick={handlePaymentTermsRemarksSubmitClick} applyThrottle={true} />
            </div>
        )
    }

    return (
        <Dialog header="" visible={visiblePaymentTermRemarks} style={{ width: isApprovalReq ? '45vw' : '30vw', height: isApprovalReq ? "45vh" : '25vh' }} onHide={() => setVisiblePaymentTermsRemarks(false)} footer={paymentTermsRemarksFooter}>
            {
                isApprovalReq &&
                <TextAreaField name="remarks" labelText="" rows={7} cols={10} placeholder="Please enter remarks for payment terms approval!" value={paymentTermsRemarks} onChange={(e) => handlePaymentTermsOnChange(e)} maxLength={1000} />
            }
            <p className="text-center font-semibold">
                {noOfDaysTakenToCreateSellerPO === 0
                    ? "Seller PO raised on the same day as the buyer PO!"
                    : `Seller PO raised ${noOfDaysTakenToCreateSellerPO} day(s) after buyer PO!`}
            </p>
        </Dialog>
    ) 
}

export default PaymentTermsApprovalRemarks